var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceApi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "service_api_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#service_api_svg__a)",
  "data-name": "Group 115"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  "data-name": "Group 114"
}, /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "M30.631 19.781a8.976 8.976 0 0 0-17.405-2.886c-.12-.006-.24-.018-.361-.018a6.864 6.864 0 1 0 0 13.728h17.236a5.425 5.425 0 0 0 .53-10.823z",
  "data-name": "Path 178"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "M29.022 15.914s8.689-2.448 15.376 5.924",
  "data-name": "Path 179"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m41.693 23.509 5.232-2.988-.118 5.964z",
  "data-name": "Path 180"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M29.198 49.509s-8.689 2.449-15.377-5.924",
  "data-name": "Path 181"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m16.527 41.914-5.233 2.988.118-5.963z",
  "data-name": "Path 182"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "M37.011 34.818h17.766v11.163H37.011z",
  "data-name": "Rectangle 73"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "M54.777 45.981 58 49.999v2.986H33.788v-2.986l3.223-4.018",
  "data-name": "Path 183"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "M33.788 49.999h16.008",
  "data-name": "Line 79"
})))));
export { SvgServiceApi as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJNMCAwaDY0djY0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJHcm91cCAxMTUiIGNsaXAtcGF0aD0idXJsKCNhKSI+PGcgZGF0YS1uYW1lPSJHcm91cCAxMTQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIj48cGF0aCBkYXRhLW5hbWU9IlBhdGggMTc4IiBkPSJNMzAuNjMxIDE5Ljc4MWE4Ljk3NiA4Ljk3NiAwIDAwLTE3LjQwNS0yLjg4NmMtLjEyLS4wMDYtLjI0LS4wMTgtLjM2MS0uMDE4YTYuODY0IDYuODY0IDAgMTAwIDEzLjcyOGgxNy4yMzZhNS40MjUgNS40MjUgMCAwMC41My0xMC44MjN6IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48cGF0aCBkYXRhLW5hbWU9IlBhdGggMTc5IiBkPSJNMjkuMDIyIDE1LjkxNHM4LjY4OS0yLjQ0OCAxNS4zNzYgNS45MjQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCAxODAiIGQ9Ik00MS42OTMgMjMuNTA5bDUuMjMyLTIuOTg4LS4xMTggNS45NjR6IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkYXRhLW5hbWU9IlBhdGggMTgxIiBkPSJNMjkuMTk4IDQ5LjUwOXMtOC42ODkgMi40NDktMTUuMzc3LTUuOTI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkYXRhLW5hbWU9IlBhdGggMTgyIiBkPSJNMTYuNTI3IDQxLjkxNGwtNS4yMzMgMi45ODguMTE4LTUuOTYzeiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTM3LjAxMSAzNC44MThoMTcuNzY2djExLjE2M0gzNy4wMTF6Ii8+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDE4MyIgZD0iTTU0Ljc3NyA0NS45ODFMNTggNDkuOTk5djIuOTg2SDMzLjc4OHYtMi45ODZsMy4yMjMtNC4wMTgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA3OSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMzMuNzg4IDQ5Ljk5OWgxNi4wMDgiLz48L2c+PC9nPjwvc3ZnPg==";